import React, { useState, useEffect, useRef } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  TimeScale,
} from "chart.js";
import "chartjs-adapter-date-fns";
import { Line } from "react-chartjs-2";
import zoomPlugin from "chartjs-plugin-zoom";
import ReactSelect from "react-select";
import yearlyData from "../../prices/tableConvert.com_2p1qty.json";
import { dropdownStyles } from "../../buy/buy";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  zoomPlugin,
  TimeScale,
  Tooltip,
  Legend
);

const LineChartMultiProducts = () => {
  const [chartData, setChartData] = useState({});
  const [markets, setMarkets] = useState([]); //The markets on the dropdown
  const [selectedMarket, setSelectedMarket] = useState(""); // The currently selected market for which the chart should display its relevant data.
  const [selectedUnit, setselectedUnit] = useState([]);
  const unitsMapRef = useRef({});
  const [minDate, setMinDate] = useState(new Date());

  console.log(selectedMarket);
  // This useEffect sets the unique products for the dropdown and initialize the selectedProduct
  useEffect(() => {
    const allMarkets = Object.keys(yearlyData[0]).slice(5);
    // console.log(allMarkets) //Debuggin Line
    // const unit = allMarkets.length > 0 ? allMarkets[0].Unit : 'No unit';
    if (allMarkets.length > 0) {
      setMarkets(
        allMarkets.map((market) => ({ value: market, label: market }))
      );
      setSelectedMarket(allMarkets[0]); // Automatically select the first market
    } else {
      console.log("No markets found in data"); // Debugging line
    }
  }, []);

  useEffect(() => {
    if (selectedMarket) {
      let dateArray = [];
      let unitsMap = {};

      const uniqueProducts = [
        ...new Set(yearlyData.map((item) => item["Product Ar"])),
      ];

      const datasets = uniqueProducts.map((product, index) => {
        const productData = yearlyData.filter(
          (item) => item["Product Ar"] === product && item[selectedMarket]
        );
        if (productData.length > 0) {
          unitsMap[product] = productData[0].Unit;
        }

        unitsMapRef.current = unitsMap;
        // const unit = productData.length > 0 ? productData[0].Unit : 'No unit';
        // console.log('unit', unit, unit.type)
        // console.log('selectedUnit:', selectedUnit);

        //  setselectedUnit(productData.length > 0 ? productData[0].Unit : 'No unit');

        yearlyData.forEach((item) => {
          if (item[selectedMarket]) {
            const date = new Date(item.Year, item.Month - 1, 1);
            dateArray.push(date);
          }
        });

        // Find the minimum and maximum dates with data
        const minDate = new Date(Math.min.apply(null, dateArray));
        const maxDate = new Date(Math.max.apply(null, dateArray));
        // console.log(minDate)

        return {
          label: product,
          //   hidden: false,
          data: productData.map((item) => ({
            x: new Date(item.Year, item.Month - 1, 1),
            y: item[selectedMarket] ? parseFloat(item[selectedMarket]) : 0,
          })),
          backgroundColor: [
            "rgba(255, 99, 132, 0.2)",
            "rgba(54, 162, 235, 0.2)",
            "rgba(255, 206, 86, 0.2)",
            "rgba(75, 192, 192, 0.2)",
            "rgba(153, 102, 255, 0.2)",
            "rgba(255, 159, 64, 0.2)",
          ],
          borderColor: [
            "rgba(255, 99, 132, 1)",
            "rgba(54, 162, 235, 1)",
            "rgba(255, 206, 86, 1)",
            "rgba(75, 192, 192, 1)",
            "rgba(153, 102, 255, 1)",
            "rgba(255, 159, 64, 1)",
          ],

          borderWidth: 1,
          tension: 0.1,
        };
      });

      //    const labels = yearlyData.map(item => `${item.Year}-${item.Month.toString().padStart(2, '0')}`);

      setChartData({
        labels: dateArray,
        datasets,
      });

      console.log("Chart data set for market:", selectedMarket);

      setselectedUnit(unitsMap);
      setMinDate(minDate);
    } else {
      setChartData({ labels: [], datasets: [] });
    }
  }, [selectedMarket]);

  const handleMarketChange = (selectedOption) => {
    setSelectedMarket(selectedOption.value);
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        type: "time",
        time: {
          unit: "month",
          tooltipFormat: "MMMM yyyy",
          //   min: minDate,
        },
        // ticks: {
        //     autoSkip: true,
        //     maxTicksLimit: 15
        //   }
      },
      y: {
        beginAtZero: true,
      },
    },
    plugins: {
      title: {
        display: false,
      },
      legend: {
        display: true,
        position: "right",
        labels: {
          usePointStyle: true,
          pointStyle: "line",
          padding: 15,
          boxWidth: 80,
        },
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            let label = context.dataset.label || "";
            if (context.parsed.y !== null) {
              const unit = unitsMapRef.current[label];
              label += ": " + context.parsed.y + " " + (unit || "");
            }
            return label;
          },
        },
      },
      zoom: {
        pan: {
          enabled: true,
          mode: "x",
        },
        zoom: {
          pinch: {
            enabled: true, // Enable pinch zooming
          },
          wheel: {
            enabled: true, // Enable wheel zooming
          },
          mode: "x",
        },
        // set limit for zooming out on the x and y axis
        limits: {
          x: {
            min: "original",
            max: "original",
          },
          y: {
            min: "original",
            max: "original",
          },
        },
      },
      transitions: {
        zoom: {
          animation: {
            duration: 1000,
            easing: "easeOutCubic",
          },
        },
      },
    },
  };

  return (
    <div className="flex flex-col items-center justify-center w-full">
      <div className="lg:mx-auto my-8 lg:mt-10  mx-2">
        <ReactSelect
          options={markets}
          onChange={(e) => setSelectedMarket(e.value)}
          // value={markets.find((market) => market.value === selectedMarket)}
          styles={dropdownStyles}
          closeMenuOnSelect={true}
          isRtl
          placeholder="المنتج"
          className="lg:w-[15rem]"
        />
        {/* <div className="lg:w-[15rem] p-2 flex justify-center items-center border-secondary border rounded-[67px] ">
            {selectedUnit} :الوحدة
          </div> */}
      </div>

      <div
        className="flex justify-center flex-col border-primary border rounded-xl shadow-lg px-1 lg:px-3 py-9 mx-auto"
        style={{ width: "1100px", margin: "auto" }}
      >
        <div className="justify-center gap-1 flex -mt-4 mb-4">
          <span className="font-bold">{selectedMarket}</span>
          <span> اسعار جميع المنتجات في </span>
        </div>

        <div style={{ width: "1050px", height: "500px" }}>
          {chartData.datasets && chartData.datasets.length > 0 && (
            <Line data={chartData} options={options} />
          )}
        </div>
      </div>
    </div>
  );
};

export default LineChartMultiProducts;
